// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__lHu1b","footerWithReportInfo":"Footer_footerWithReportInfo__16vxG","footerText":"Footer_footerText__HLuh1","footerWhite":"Footer_footerWhite__rGzQK"};